import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';
import { urls } from 'shared/constants/routing.constants';
import {
  FOOTER_LINKS_TEXT,
  FOOTER_SOCIAL_LINKS,
  FOOTER_LINKS,
} from 'shared/constants/footer-constants';
import CustomLink from 'components/CustomLink/CustomLink';
import { Logo } from 'components/Logo/Logo';
import { MailToLink } from 'components/LegalPagesLinks/MailToLink';

const Footer: React.FC = () => (
  <Stack
    sx={{
      p: { lg: '40px', md: '24px 22px', xs: '24px 22px 112px' },
      backgroundColor: 'myGrey.grey100',
      rowGap: { lg: '24px', xs: '16px' },
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
      <Logo />
      <Stack direction="row" justifyContent="space-between" columnGap="24px">
        <CustomLink href={urls.commonPages.about} sx={{ fontWeight: 700 }}>
          {FOOTER_LINKS_TEXT.about}
        </CustomLink>
      </Stack>
    </Stack>
    <Box
      sx={{
        width: '100%',
        height: '1px',
        backgroundColor: 'primary.main',
        mb: { lg: '28px', xs: '8px' },
      }}
    />
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      mb={{ md: '6px', xs: '24px' }}
    >
      <MailToLink />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        columnGap={{ md: '24px', xs: '8px' }}
      >
        {FOOTER_SOCIAL_LINKS.map((link) => (
          <CustomLink
            key={link.icon}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ lineHeight: '0' }}
          >
            <CustomMuiIcon
              type={link.icon}
              sx={{
                fontSize: { lg: '44px', xs: '37px' },
                '&:hover path': {
                  fill: (theme) => theme.palette.myGrey.grey800,
                },
              }}
            />
          </CustomLink>
        ))}
      </Stack>
    </Stack>
    <Stack
      direction={{ md: 'row', xs: 'column-reverse' }}
      rowGap="24px"
      justifyContent="space-between"
      alignItems={{ md: 'center', xs: 'flex-end' }}
      width="100%"
      flexWrap="wrap-reverse"
    >
      <Typography
        variant="subtitle2"
        color="primary.main"
        sx={{ fontSize: { lg: '16px', xs: '14px' } }}
      >
        {FOOTER_LINKS_TEXT.copyright}
      </Typography>
      <Stack
        direction={{ md: 'row', xs: 'column' }}
        justifyContent="space-between"
        alignItems={{ md: 'center', xs: 'flex-start' }}
        columnGap="24px"
        rowGap="12px"
      >
        {FOOTER_LINKS.map((link) => (
          <CustomLink key={link.text} href={link.href} sx={{ fontSize: { lg: '16px' } }}>
            {link.text}
          </CustomLink>
        ))}
      </Stack>
    </Stack>
  </Stack>
);

export default Footer;
